export default __webpack_public_path__ + "static/angajati-si-societate-bbd4845c38394ea5952903a143ca318b.jpg";